import React, { useState } from 'react'
import { Grid, useMediaQuery } from '@material-ui/core'
import "./digital-vault-categories-administration-details.css"
import categories_icons from './categories_icons'
import { RadioButton } from '@progress/kendo-react-inputs'
import { DialogTemplatePure } from '../../pures'
import { DropDownBtnHLPure, InputHLPure, TextAreaHLPure, ButtonHLPure, ButtonAddHLPure } from '../../pures'
import { useTranslation } from 'react-i18next'
import { NIL } from 'uuid'

const DigitalVaultCategoriesAdministrationDetailsView = (props) => {
    const { selectedUser, setShowDetails, updateCategory, categories, selectedValueFilter, unassignCategory, deleteCategory } = props
    const { t } = useTranslation()
    const dropdownOptions = [
        { name: t("digitalVaultCategoriesAdministration.details.options.notAssigned"), levelUser: "" },
        { name: t("digitalVaultCategoriesAdministration.details.options.administrator"), levelUser: Number(process.env.REACT_APP_COMPANY_ROLE_ID_ADMIN) },
        { name: "N1", levelUser: Number(process.env.REACT_APP_COMPANY_ROLE_ID_N1) },
        { name: "N2", levelUser: Number(process.env.REACT_APP_COMPANY_ROLE_ID_N2) },
        { name: "N3", levelUser: Number(process.env.REACT_APP_COMPANY_ROLE_ID_N3) }
    ]

    const [categoryData, setCategoryData] = useState
        (
            {
                name: selectedUser.name,
                defined: selectedUser.defined,
                notes: selectedUser.notes ?? "",
                levelUser: selectedUser.levelUser,
                icon: selectedUser.icon ?? null
            }
        )

    const [saveImage, setSaveImage] = useState(selectedUser.icon)
    const selectedFilterText = categories.find(item => item.company.id === selectedValueFilter).company.companyName

    const deleteCategoryDefaultOrCustom = () => selectedValueFilter !== NIL && !selectedUser.companyId ? deleteCategory(selectedValueFilter, selectedUser.categoryId) : deleteCategory(selectedUser.companyId, selectedUser.categoryId)

    const unnassignCategoryDefaultOrCustom = () => selectedValueFilter !== NIL && !selectedUser.companyId ? unassignCategory(selectedValueFilter, selectedUser.categoryId) : unassignCategory(selectedUser.companyId, selectedUser.categoryId)

    const [showAddIcon, setShowAddIcon] = useState(false)

    const isMobile = useMediaQuery("(max-width:560px")

    return (
        <>
            <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="digitalVaultCategoriesAdministrationDetails-wrapper"
            >
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="digitalVaultCategoriesAdministrationDetails-paddingElements"
                >
                    <span>
                        {t("digitalVaultCategoriesAdministration.details.categoryApplies")} <b>{selectedFilterText}</b>
                    </span>
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="digitalVaultCategoriesAdministrationDetails-paddingElements"
                >
                    <InputHLPure
                        labelInput={t("digitalVaultCategoriesAdministration.details.categoryType")}
                        typeInput={"text"}
                        inputActive
                        valueInput={categoryData.defined}
                        disabled
                    />
                </Grid>
                {categoryData.defined === t("digitalVaultCategoriesAdministration.main.grid.custom") &&
                    <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="digitalVaultCategoriesAdministrationNewCategory-paddingElements digitalVaultCategoriesAdministrationDetails-modifyButton"
                    >
                        <ButtonAddHLPure
                            nameBtn={t("digitalVaultCategoriesAdministration.details.modifyIcon")}
                            onClickBtn={() => setShowAddIcon(true)}
                        />
                    </Grid>
                }
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className='digitalVaultCategoriesAdministrationDetails-paddingElements'
                >
                    <InputHLPure
                        labelInput={t("digitalVaultCategoriesAdministration.details.category")}
                        disabled={selectedUser.defined === t("digitalVaultCategoriesAdministration.main.grid.default")}
                        valueInput={categoryData.name}
                        typeInput={"text"}
                        required={selectedUser.defined === t("digitalVaultCategoriesAdministration.main.grid.custom")}
                        inputActive
                        handleChangeInput={(e) => setCategoryData({ ...categoryData, name: !e.target.value ? null : e.target.value })}
                        informationIcon
                        tooltipShow
                        positionTooltip={isMobile ? "top" : "right"}
                        titleTooltip={t("digitalVaultCategoriesAdministration.details.category")}
                        descriptionTooltip={selectedUser.defined === t("digitalVaultCategoriesAdministration.main.grid.default") ? t("digitalVaultCategoriesAdministration.details.tip.enterCategoryDefault") : t("digitalVaultCategoriesAdministration.details.tip.enterCategory")}
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className='digitalVaultCategoriesAdministrationDetails-paddingElements'
                >
                    <DropDownBtnHLPure
                        labelDropDown={t("digitalVaultCategoriesAdministration.details.minimumVisualization")}
                        optionsDropDown={dropdownOptions}
                        onDropDownChange={e => setCategoryData({ ...categoryData, levelUser: e.target.value })}
                        optionsValue={categoryData.levelUser}
                        valueItem={"levelUser"}
                        nameOption={"name"}
                        informationIcon
                        tooltipShow
                        positionTooltip={isMobile ? "top" : "right"}
                        titleTooltip={t("digitalVaultCategoriesAdministration.details.visualizationLevel")}
                        descriptionTooltip={t("digitalVaultCategoriesAdministration.details.descMinimumVisualization")}
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="digitalVaultCategoriesAdministrationDetails-paddingElements"
                >
                    <TextAreaHLPure
                        labelTextArea={t("digitalVaultCategoriesAdministration.details.notes")}
                        handleChangeTextArea={(e) => setCategoryData({ ...categoryData, notes: e.target.value })}
                        valueTextData={categoryData.notes ?? ""}
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="digitalVaultCategoriesAdministrationDetails-container-btn"
                >
                    <div className="digitalVaultCategoriesAdministrationDetails-btn-cancel">
                        <ButtonHLPure
                            nameBtn={t("button.cancel")}
                            onClickBtn={() => setShowDetails(false)}
                        />
                    </div>

                    {selectedUser.defined === t("digitalVaultCategoriesAdministration.main.grid.custom")
                        ?
                        <div className="digitalVaultCategoriesAdministrationDetails-btn-cancel">
                            <ButtonHLPure
                                nameBtn={t("button.delete")}
                                onClickBtn={() => deleteCategoryDefaultOrCustom()}
                            />
                        </div>
                        :
                        <div className="digitalVaultCategoriesAdministrationDetails-btn-cancel">
                            <ButtonHLPure
                                nameBtn={t("button.unassign")}
                                onClickBtn={() => unnassignCategoryDefaultOrCustom()}
                            />
                        </div>
                    }
                    <ButtonHLPure
                        nameBtn={t("button.save")}
                        primary
                        onClickBtn={() => updateCategory(categoryData.name, categoryData.notes, categoryData.levelUser, selectedUser.companyCategoryId, categoryData.icon)}
                    />
                </Grid>
            </Grid>
            {showAddIcon && (
                <DialogTemplatePure
                    cancel={() => setShowAddIcon(false)}
                    title="govo.digital"
                    description={t("digitalVaultCategoriesAdministration.details.selectIconCategory")}
                    canelBtn={t("button.cancel")}
                    saveBtn={t("button.save")}
                    buttonStyles="digitalVaultCategoriesAdministrationNewCategory-align-buttons"
                    handleSubmitProfile={(event) => {
                        event.preventDefault()
                        setCategoryData({ ...categoryData, icon: saveImage })
                        setShowAddIcon(false)
                    }
                    }
                >
                    <div
                        className="signatureProfilesDetailsView-container-gallery"
                        xs={12}
                    >
                        {categories_icons.map((item, index) => (
                            <div className="signatureProfilesDetailsView-container-icons">
                                <RadioButton
                                    className="signatureProfilesDetailsView-radioBtn-img"
                                    name="icon"
                                    value={item.relativePath}
                                    checked={saveImage === item.relativePath}
                                    onChange={({ value }) => setSaveImage(value)}
                                />
                                <img
                                    src={item.url}
                                    className="icon-style"
                                    key={index}
                                />
                            </div>
                        ))}
                    </div>
                </DialogTemplatePure>
            )}
        </>

    );
}

export default DigitalVaultCategoriesAdministrationDetailsView